import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { Tab } from "@headlessui/react";
import { BellIcon } from "@heroicons/react/24/outline";
import clsx from "clsx"; // For class merging
import React, { useState, useEffect } from "react";
import useDashBoard from "../../../pages/dashBoards/useDashBoard";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ROUTE_CONSTANT from "../../../routes/routeconstants";
import toast from "../../../components/toast/index";
import { useTranslation } from "react-i18next";
import BackdropLoader from "../../loader/BackdropLoader";
import "../../../theme/style.css";
import { HrmYellowBtn } from "../../Buttons";
export default function NotificationTabComponent() {
  const [value, setValue] = useState("2");
  const user = useSelector((state) => state.user.userData);
  const navigate = useNavigate();
  const { t } = useTranslation("translations");
  const [unreadJobs, setUnreadJobs] = useState([]);
  const [readJobs, setReadJobs] = useState([]);
  const [unreadApplicants, setUnreadApplicants] = useState([]);
  const [readApplicants, setReadApplicants] = useState([]);

  const {
    Notificationalldata,
    getNotificationall,
    updatenotification,
    updatePlacement,
    updatedJob,
    updatedapplicant,
    updateclient,
    updatevendor,
    updateshift,
    updatesurvey,
    updatetask,
    updatesubvendor,
    updateinterview,
    NotificationLoading,
  } = useDashBoard({
    orgId: user?.orgId,
    userId: user.userId,
  });

  const handleNotificationClick = async (Id) => {
    try {
      const { data } = await updatenotification({
        variables: {
          input: {
            orgId: user.orgId,
            Id: Id,
            readByUser: [user.userId],
          },
        },
      });
    } catch (error) {
      toast.error("Error updating notification:", error);
      // Handle error or display a message to the user
    }
  };



  const handleApplicantClick = async (applicant) => {
    const applicantId = applicant?.split(" ")[0];
    try {
      // Call the backend mutation to update isBoolean to true
      await updatedapplicant({
        variables: {
          input: {
            applicantId: applicantId,
            isBoolean: true,
          },
        },
      });
    } catch (error) {
      toast.error("Error updating applicant status:", error);
      // Handle error or display a message to the user
    }
  };
  const InterviewClick = async (interview) => {
    const interviewId = interview?.split(" ")[0];
    try {
      // Call the backend mutation to update isBoolean to true
      await updateinterview({
        variables: {
          input: {
            Id: +interviewId,
            isBoolean: true,
          },
        },
      });
    } catch (error) {
      toast.error("Error updating interview status:", error);
      // Handle error or display a message to the user
    }
  };




  const handleSurveyClick = async (survey) => {
    const surveyId = survey?.split(" ")[0];
    try {
      await updatesurvey({
        variables: {
          input: {
            Id: +surveyId,
            isBoolean: true,
          },
        },
      });
    } catch (error) {
      toast.error("Error updating survy status:", error);
      // Handle error or display a message to the user
    }
  };



  const handleShiftClick = async (shift) => {};
  useEffect(() => {
    getNotificationall();
  }, []);

  const dashboardNotifications = Notificationalldata?.dashboardNotificationAll;

  useEffect(() => {
    // Initialize unread and read jobs from dashboardNotifications
    setUnreadJobs(dashboardNotifications?.jobNotification?.unreadJobs || []);
    setReadJobs(dashboardNotifications?.jobNotification?.readJobs || []);
    setUnreadApplicants(
      dashboardNotifications?.applicantNotification?.unreadApplicants || []
    );
    setReadApplicants(
      dashboardNotifications?.applicantNotification?.readApplicants || []
    );
  }, [dashboardNotifications]);


    

  const totalNotificationCount =
    (dashboardNotifications?.anniversary?.length || 0) +
    (dashboardNotifications?.birthday?.length || 0) +
    (dashboardNotifications?.applicantMapNotification?.length || 0) +
    (dashboardNotifications?.applicantNotification?.unreadApplicants?.length ||
      0) +
    
    (dashboardNotifications?.jobNotification?.unreadJobs?.length || 0) +
    (dashboardNotifications?.orglevelNotification?.length || 0) +
     (dashboardNotifications?.attendanceouttimeNotification?.length || 0) +
    
    (dashboardNotifications?.scheduleNotification?.unreadInterviews?.length ||
      0) +
    
  
    (dashboardNotifications?.surveyNotification?.unreadSurveys?.length || 0) +
   
    (dashboardNotifications?.scheduleupdatedNotification?.length || 0) +
 
    (dashboardNotifications?.taskAssignNotification?.length || 0) +
    (dashboardNotifications?.taskendNotification?.unreadTasks?.length || 0) +
    (
      dashboardNotifications?.subvendorNotification?.unreadSubVendors?.length ||
      0
    ) +
    (dashboardNotifications?.employeePerformanceNotification?.length || 0) +
    (dashboardNotifications?.employeeSurveyAssignNotification?.length || 0) +
    (dashboardNotifications?.employeesurveyNotification?.length || 0) +
    (dashboardNotifications?.shiftAssignNotification?.unreadShifts?.length ||
      0)+
       (dashboardNotifications?.voucherNotifications?.length ||
      0) ;
   
    let readNotificationsCount = 0;

  for (const notification of dashboardNotifications?.orglevelNotification ||
    []) {
    if (notification.readByUser?.includes(user?.userId)) {
      readNotificationsCount++;
    }
  }
  const totalCount = totalNotificationCount - readNotificationsCount;
  const handelNClick = () => {
    setNbox(false);
  };

  return (
    <Popover className="relative flex justify-center">
      <PopoverButton className="relative text-gray-900 focus:ring-0 focus:outline-none">
        <span className="sr-only">View notifications</span>
        <BellIcon aria-hidden="true" className="!size-6 border border-none" />
        {/* Notification Badge */}
        {totalCount > 0 && (
          <span className="absolute top-0 -right-1 w-4 h-4 text-xs font-bold text-black rounded-full flex items-center justify-center">
            {totalCount}
          </span>
        )}
      </PopoverButton>

      <PopoverPanel className="absolute right-0 top-full z-[9999] mt-4 w-76 bg-white rounded-lg shadow-lg ring-1 ring-gray-900/5">
        <div className="flex justify-center items-center p-2">
          <a
            href="/notification"
            className="text-sm text-blue-500 hover:underline p-1"
            onClick={handelNClick}
          >
            View Notifications
          </a>
        </div>
        <Tab.Group>
          <Tab.List className="flex p-1 space-x-1 bg-gray-200 rounded-lg">
            <Tab
              className={({ selected }) =>
                clsx(
                  "w-full py-2 text-sm font-medium rounded-lg",
                  selected ? "bg-[#9fe0ed] text-black" : "text-gray-700"
                )
              }
            >
              Unread
            </Tab>
            <Tab
              className={({ selected }) =>
                clsx(
                  "w-full py-2 text-sm font-medium rounded-lg",
                  selected ? "bg-[#9fe0ed] text-black" : "text-gray-700"
                )
              }
            >
              Read
            </Tab>
          </Tab.List>

          <Tab.Panels className="mt-2 p-3 overflow-y-auto max-h-[280px]">
            {/* UnRead Messages */}
            <Tab.Panel>
              <div className="space-y-2">
                {true ? (
                  <div>
                    {/* Anniversary Notifications */}
                    {dashboardNotifications?.anniversary.map((i, index) => (
                      <div
                        key={index}
                        className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                      >
                        {i}
                      </div>
                    ))}
                    {/*payment remainder biz work*/}
                    {dashboardNotifications?.voucherNotifications?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"

                          onClick={() => {
                            navigate(`${ROUTE_CONSTANT.APPROVALS}`);
                          }}
                        >
                          {i?.message}
                        </div>
                      )
                    )}
                 
                  
                

                    {/* Birthday Notifications */}
                    {dashboardNotifications?.birthday.map((i, index) => (
                      <div
                        key={index}
                        className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                      >
                        {i}
                      </div>
                    ))}

                   
                    {/* Job Notifications */}
                    {dashboardNotifications?.jobNotification?.unreadJobs?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                          // ata-notification-id={i?.jobId}
                          onClick={() => handleJobClick(i)}
                        >
                          {i}
                        </div>
                      )
                    )}

                    {/* Orglevel Notifications */}
                    {/* {dashboardNotifications?.orglevelNotification.map((i, index) => (
              <div key={index} className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]">{i}</div>
            ))} */}
                    {dashboardNotifications?.orglevelNotification.map(
                      (notification, index) =>
                        !notification?.readByUser?.includes(user.userId) && (
                          <div
                            key={index}
                            data-notification-id={notification?.Id}
                            className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                            onClick={() =>
                              handleNotificationClick(notification?.Id)
                            }
                          >
                            {notification.message}
                          </div>
                        )
                    )}
                   
                  

                    {dashboardNotifications?.attendanceouttimeNotification?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                          onClick={() => {
                            navigate(`${ROUTE_CONSTANT.MYTIME}`);
                          }}
                        >
                          {i}
                        </div>
                      )
                    )}
                   
                    {dashboardNotifications?.scheduleNotification?.unreadInterviews?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                        >
                          {i}
                        </div>
                      )
                    )}
                  
                   
                 

                    {dashboardNotifications?.shiftAssignNotification?.unreadShifts?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                          onClick={() => handleShiftClick(i)}
                        >
                          {i}
                        </div>
                      )
                    )}
                 
                  
                    {dashboardNotifications?.surveyNotification?.unreadSurveys?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                          onClick={() => handleSurveyClick(i)}
                        >
                          {i}
                        </div>
                      )
                    )}
                    {dashboardNotifications?.taskendNotification?.unreadTasks?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                          onClick={() => handleTaskClick(i)}
                        >
                          {i}
                        </div>
                      )
                    )}
                    {dashboardNotifications?.scheduleupdatedNotification?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                        >
                          {i}
                        </div>
                      )
                    )}
                    {dashboardNotifications?.interviewStatusapplicant?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                        >
                          {i}
                        </div>
                      )
                    )}
                    {dashboardNotifications?.compensations?.map((i, index) => (
                      <div
                        key={index}
                        className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                        onClick={async () => {
                          if (i.includes("expiring")) {
                            navigate(`${ROUTE_CONSTANT.VIEW_EMPLOYEE}`);
                          }
                        }}
                      >
                        {i}
                      </div>
                    ))}
                  
                    {dashboardNotifications?.taskAssignNotification?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                        >
                          {i}
                        </div>
                      )
                    )}
                   
               

                    {dashboardNotifications?.employeePerformanceNotification?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                          onClick={() => navigate(`${ROUTE_CONSTANT.RESPONSE}`)}
                        >
                          {i}
                        </div>
                      )
                    )}
                    {dashboardNotifications?.employeeSurveyAssignNotification?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                          onClick={() =>
                            navigate(
                              `${ROUTE_CONSTANT.EMPLOYEE_SURVEY_DETAILS}`
                            )
                          }
                        >
                          {i}
                        </div>
                      )
                    )}
                    {dashboardNotifications?.employeesurveyNotification?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                        >
                          {i}
                        </div>
                      )
                    )}

                    {dashboardNotifications?.scheduleupdatedNotification?.map(
                      (i, index) => (
                        <div
                          key={index}
                          className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                        >
                          {i}
                        </div>
                      )
                    )}
                  
              

                  
                  </div>
                ) : (
                  <p className="text-sm text-gray-500">No read messages</p>
                )}
              </div>
            </Tab.Panel>
            {/* Read Messages */}
            <Tab.Panel>
              <div className="space-y-2">
                {true ? (
                  <div className="">
                    <>
                      {dashboardNotifications?.orglevelNotification.map(
                        (notification, index) => {
                          return (
                            notification?.readByUser?.includes(user.userId) &&
                            notification.message && (
                              <div
                                key={index}
                                data-notification-id={notification?.Id}
                                className="mb-2 cursor-pointer rounded-lg bg-orange-100 p-2 text-sm text-gray-900 shadow-sm transition-colors duration-200 hover:bg-[var(--primary-background)]"
                              >
                                {notification.message}
                              </div>
                            )
                          );
                        }
                      )}

                      {/* Job Notifications */}

                      {readJobs.map((jobId, index) => (
                        <div
                          key={index}
                          className="mb-2 rounded-lg cursor-pointer bg-orange-100 p-2 text-sm text-gray-900 shadow-sm"
                        >
                          {jobId}
                        </div>
                      ))}
                      {/* applicant Notifications */}

                      {readApplicants.map((applicantId, index) => (
                        <div
                          key={index}
                          className="mb-2 rounded-lg cursor-pointer bg-orange-100 p-2 text-sm text-gray-900 shadow-sm"
                        >
                          {applicantId}
                        </div>
                      ))}
                    
                
                   

                   


                      
                    </>
                  </div>
                ) : (
                  <p className="text-sm text-gray-500">No unread messages</p>
                )}
              </div>
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
        {/* <Notifications /> */}
      </PopoverPanel>
    </Popover>
  );
}
